import React from 'react';
import App from './App';
import { AuthProvider } from './authentication/AuthContext';
import { createRoot } from 'react-dom/client';

const domNode = document.getElementById('root');
const root = createRoot(domNode);

// Remove console.log statements in production
// This is a simple way to disable console logs in production builds
if (process.env.NODE_ENV === 'production') console.log = function () {};
if (process.env.NODE_ENV === 'prod') console.log = function () {};
console.log('Running in', process.env.NODE_ENV, 'mode');

root.render(
  <React.StrictMode>
    <AuthProvider>
        <App />
    </AuthProvider>
  </React.StrictMode>,
);